import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { SVG_GRADIENT_BLUE } from '../Button/ButtonStyles';

export const useStyles = () => ({
    openTicketContainer: css({
        boxSizing: "border-box",
        padding: 24,
        width: "100%",
        height: 208,
        backgroundSize: "0% 100%",
        backgroundRepeat: "no-repeat",
        backgroundOrigin: "border-box",
        border: `4px solid ${Color.primary[600]}`,
        borderImage: `url('data:image/svg+xml;base64,${SVG_GRADIENT_BLUE}') 10% stretch`,
        backgroundImage: Color.gradient[100],
        transition: "all .2s ease-in-out",
        "&:hover": {
            border: `4px solid ${Color.primary[400]}`,
            backgroundColor: Color.primary[400],
            color: `${Color.neutral[0]} !important`,
        },
    }),
    openTicket: css({
        display: "flex",
        alignItems: "baseline",
        justifyContent: "center",
    }),
});
